const zh = {
  toHome: '正在为您跳转首页...',
  loginSuccess: '登录成功',
  loginFailed: '登录失败',
  acntNotExist: '账号不存在,请检查',
  acntOrPwdError: '账号或者密码错误',
  checkFailed: '校验失败',
  selOrg: '请选择您要进入的组织',
  orgTip1: '该帐号参与组织不存在，且没有参与其他组织，请联系管理员。',
  login: '登录',
  carousel: '轮播图',
  acnt: '账号',
  enterAcnt: '请输入',
  pwd: '密码',
  enterPwd: '请输入您的密码',
  remberPwd: '记住密码',
  noOrgTip1: '该账户没有参与组织，请联系管理员',
  pageNotFoundTitle: '找不到该页面',
  pageNotFoundTip: '抱歉，您访问的页面不存在。',
  goToBackHome: '返回首页',
  phoneDisabledTip: '该手机号已被禁用，请联系管理员。',
  welcome: '欢迎来到{{ name }}'
};

export default zh;